import { render, staticRenderFns } from "./AdministrativePageWelcome.vue?vue&type=template&id=db45269c"
import script from "./AdministrativePageWelcome.vue?vue&type=script&lang=js"
export * from "./AdministrativePageWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports